import pdfobject from "pdfobject";
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Stack, Grid, Typography, CardMedia, CircularProgress, LinearProgress, Avatar, ListItemIcon, Button, Divider, Alert, AlertTitle } from '@mui/material';
import { Card, CardContent, ToggleButtonGroup, ToggleButton } from '@mui/material';
import { ListItem, ListItemText, ListItemAvatar } from '@mui/material';
import { Dialog, DialogActions, DialogContent } from '@mui/material';

import { formatDistance } from "date-fns";
import { convertMsToTime, urlToFile } from "../utilities/common";

import { Geolocation } from '@capacitor/geolocation';
import { Device } from '@capacitor/device';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

import Webcam from "react-webcam";

import { pb } from "../utilities/pocketbase";

import { AuthRequiredComponent } from "../components/Auth";

import CRRaoAIMSCSLogo from '../crrao_aimscs_logo-min.png';

import FinalistInstructions from "../components/FinalistInstructions";

import TaskIcon from '@mui/icons-material/Task';
import StopIcon from '@mui/icons-material/Stop';
import InfoIcon from '@mui/icons-material/Info';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';

const videoConstraints = {
    width: 1280,
    height: 720,
    facingMode: "user"
};

const USER_TYPE = "finalist"
const NO_OF_QUESTIONS = 25

export default function FinalExamView() {
    const [dimensions, setDimensions] = useState({
        height: window.innerHeight,
        width: window.innerWidth
    })
    const [userData, setUserData] = useState({})
    const [visitorId, setVisitorId] = useState("")
    const [deviceId, setDeviceId] = useState("")
    const [userAttempts, setUserAttempts] = useState({})
    const [examState, setExamState] = useState({ started: false, ended: false, ongoing: false })
    const [error, setError] = useState("")
    const [openOutOfFocusWarning, setOpenOutOfFocusWarning] = useState(false)
    const [mediaDevices, setMediaDevices] = useState([])
    const [screenStream, setScreenStream] = useState()
    const webcamRef = useRef(null);

    useEffect(() => {
        function handleResize() {
            setDimensions({
                height: window.innerHeight,
                width: window.innerWidth
            })
        }
        window.addEventListener('resize', handleResize)
        return _ => {
            window.removeEventListener('resize', handleResize)
        }
    })

    useEffect(() => {
        window.document.title = "Exam"
        console.log("finalist load...")
        if (pb?.authStore?.model?.id) {
            pb.collection('finalists')
                .getOne(`${pb?.authStore?.model?.id}`, {
                    expand: 'questionpaper, questionpaper.exam, exam',
                }).then(finalist => {
                    // console.log("finalist: ", finalist)
                    setUserData(finalist)
                    if (pdfobject.supportsPDFs) {
                        console.log("does support pdfObject")
                        const { questionpaper } = finalist.expand
                        // console.log("qp:", questionpaper, `${process.env.REACT_APP_PB_URL}/api/files/${questionpaper?.collectionId}/${questionpaper?.id}/${questionpaper?.questionpaper}`)
                        pdfobject.embed(questionpaper?.questionpaperlink ? questionpaper?.questionpaperlink : `${process.env.REACT_APP_PB_URL}/api/files/${questionpaper?.collectionId}/${questionpaper?.id}/${questionpaper?.questionpaper}`, "#FinalQuestionPaper")
                    } else {
                        console.log("doesn't support pdfObject")
                    }
                    pb.collection('finalist_attempts')
                        .getList(1, 100, {
                            filter: `questionpaper = '${finalist?.questionpaper}'`,
                        }).then(attempts => {
                            setUserAttempts(attempts)
                        }).catch(error => {
                            console.log("attempts error:", error)
                            // setError(error?.message)
                        })

                    if (new Date().getTime() < new Date(finalist?.expand?.questionpaper?.expand?.exam?.ends).getTime()) {
                        if (webcamRef && webcamRef?.current) {
                            const imageSrc = webcamRef?.current?.getScreenshot();
                            // console.log("imageSrc:", imageSrc)
                            if (imageSrc) {
                                urlToFile(imageSrc, `${pb?.authStore?.model?.id}_${new Date().getTime()}`).then(file => {
                                    // console.log("image file: ", file)
                                    const data = new FormData()
                                    data.append(USER_TYPE, pb?.authStore?.model?.id)
                                    data.append("camera_capture", file)
                                    data.append("remark", "loading...")
                                    pb.collection('finalist_camera_captures').create(data).then(record => {
                                        console.log("record created", record)
                                    }).catch(err => {
                                        console.log("record create error", err)
                                    })
                                }).catch(err => {
                                    console.log("image file error", err)
                                })
                            }
                        }
                    }
                }).catch(error => {
                    console.log("finalist error:", error)
                    setError(error?.message)
                })
        } else {
            console.log("finalist auth error:")
        }

        return () => {
            window.document.title = process.env.REACT_APP_NAME
            document.removeEventListener('visibilitychange', (e) => console.log(e))
        }
    }, [examState.started, examState.ended, examState.ongoing])

    useEffect(() => {
        if (userData && userData?.expand) {
            if (pdfobject.supportsPDFs) {
                console.log("does support pdfObject")
                const { questionpaper } = userData.expand
                // console.log("qp:", questionpaper, `${process.env.REACT_APP_PB_URL}/api/files/${questionpaper?.collectionId}/${questionpaper?.id}/${questionpaper?.questionpaper}`)
                pdfobject.embed(questionpaper?.questionpaperlink ? questionpaper?.questionpaperlink : `${process.env.REACT_APP_PB_URL}/api/files/${questionpaper?.collectionId}/${questionpaper?.id}/${questionpaper?.questionpaper}`, "#FinalQuestionPaper")
            } else {
                console.log("doesn't support pdfObject")
            }

            const watcher = setInterval(() => {
                if (new Date().getTime() < new Date(userData?.expand?.questionpaper?.expand?.exam?.ends).getTime()) {
                    if (webcamRef && webcamRef?.current) {
                        const imageSrc = webcamRef?.current?.getScreenshot();
                        // console.log("imageSrc:", imageSrc)
                        if (imageSrc) {
                            urlToFile(imageSrc, `${pb?.authStore?.model?.id}_${new Date().getTime()}`).then(file => {
                                // console.log("image file: ", file)
                                const data = new FormData()
                                data.append(USER_TYPE, pb?.authStore?.model?.id)
                                data.append("camera_capture", file)
                                data.append("remark", "regular watch")
                                pb.collection('finalist_camera_captures').create(data).then(record => {
                                    console.log("record created", record)
                                }).catch(err => {
                                    console.log("record create error", err)
                                })
                            }).catch(err => {
                                console.log("image file error", err)
                            })
                        }
                    }
                }
            }, 1000 * 60 * 10);

            return () => {
                console.log("clearing watcher...")
                clearInterval(watcher)
            }
        }
    }, [userData])

    useEffect(() => {
        if (pb?.authStore?.model?.id) {
            Device.getId().then(deviceId => {
                // console.log("deviceId:", deviceId)
                const { identifier } = deviceId
                setDeviceId(identifier)
                Device.getInfo().then(deviceInfo => {
                    // console.log("deviceInfo:", deviceInfo)
                    const data = {
                        finalist: pb?.authStore?.model?.id,
                        deviceId: identifier,
                        deviceInfo: deviceInfo
                    }
                    pb.collection('finalist_devices').create(data).then(record => {
                        console.log("device record created: ", record)
                    }).catch(error => {
                        console.log("device record create error: ", error)
                    })
                }).catch(error => console.log("getDeviceInfoError:", error))
            }).catch(error => console.log("getDeviceIDError:", error))

            Geolocation.getCurrentPosition({ timeout: 10000, enableHighAccuracy: true }).then(geoLocation => {
                const { accuracy, altitude, altitudeAccuracy, heading, latitude, longitude, speed } = geoLocation.coords
                const data = {
                    finalist: pb?.authStore?.model?.id,
                    latitude: latitude,
                    longitude: longitude,
                    accuracy: accuracy,
                    altitude: altitude,
                    altitudeAccuracy: altitudeAccuracy,
                    heading: heading
                }
                console.log("geolocation: ", geoLocation)
                pb.collection('finalist_locations').create(data).then(location => {
                    console.log("location created: ", location)
                }).catch(error => console.log("location create error:", error))
            }).catch(error => console.log("geoLocation error:", error))

            FingerprintJS.load().then((fp) => fp.get()).then((result) => {
                setVisitorId(result?.visitorId)
                const processedData = {
                    visitorId: result?.visitorId,
                    confidence: result?.confidence?.score,
                    components: { ...result?.components, canvas: undefined }
                }
                pb.collection('fingerprints').create(processedData).then(record => {
                    console.log("fingerprint record created: ", record)
                }).catch(error => {
                    console.log("fingerprint record create error: ", error)
                })
            })

            navigator.mediaDevices.enumerateDevices().then(mediaDeviceList => {
                setMediaDevices(mediaDeviceList.filter(({ kind }) => kind === "videoinput"))
            })

            // navigator.mediaDevices.getDisplayMedia({
            //     video: {
            //         displaySurface: "monitor",
            //         cursor: "always",
            //     }
            // }).then(stream => {
            //     setScreenStream(stream)
            //     console.log("screen stream: ", stream)
            // }).catch((err) => {
            //     console.error(err);
            //     return null;
            // });
        }
    }, [])

    // useEffect(() => {
    //     if (screenStream) {
    //         return () => {
    //             const tracks = screenStream.getTracks();
    //             tracks.forEach(function (track) {
    //                 track.stop();
    //             });
    //         }
    //     }
    // }, [screenStream])

    useEffect(() => {
        if (visitorId && userData) {
            document.addEventListener("visibilitychange", (event) => {
                if (document.visibilityState === "visible") {
                    if (pb?.authStore?.model?.id && visitorId) {
                        console.log("tab is active")
                        window.document.title = '🟢 On screen'
                    }
                } else {
                    console.log("tab is inactive")
                    if (pb?.authStore?.model?.id && visitorId) {
                        window.document.title = '🔴 Off screen'
                        const data = { finalist: pb?.authStore?.model?.id, fingerprint: visitorId }
                        if (new Date().getTime() < new Date(userData?.expand?.questionpaper?.expand?.exam?.ends).getTime()) {
                            pb.collection('finalist_outoffocuses').create(data).then(record => {
                                console.log("out of focus record created: ", record)
                                setOpenOutOfFocusWarning(true)
                            }).catch(error => {
                                console.log("out of focus record create error: ", error)
                            })
                            if (webcamRef && webcamRef?.current) {
                                const imageSrc = webcamRef?.current?.getScreenshot();
                                // console.log("imageSrc:", imageSrc)
                                if (imageSrc) {
                                    urlToFile(imageSrc, `${userData?.id}_${new Date().getTime()}`).then(file => {
                                        // console.log("image file: ", file)
                                        const data = new FormData()
                                        data.append(USER_TYPE, userData?.id)
                                        data.append("camera_capture", file)
                                        data.append("remark", "lost focus")
                                        pb.collection('finalist_camera_captures').create(data).then(record => {
                                            console.log("record created", record)
                                        }).catch(err => {
                                            console.log("record create error", err)
                                        })
                                    }).catch(err => {
                                        console.log("image file error", err)
                                    })
                                }
                            }
                        }
                    }
                }
            });

            return _ => {
                document.removeEventListener('visibilitychange', (e) => console.log(e))
            }
        }

        return _ => {
            document.removeEventListener('visibilitychange', (e) => console.log(e))
        }
    }, [visitorId, userData])

    function toggleFullScreen() {
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen();
        } else if (document.exitFullscreen) {
            document.exitFullscreen();
        }
    }

    return (
        <Grid container gap={.5} justifyContent={"center"} alignItems={"center"} sx={{ py: 2 }}>
            <Grid item xs={12} sm={12} md={7} lg={8}>
                <ExamStatus userData={userData} startsAt={userData?.expand?.questionpaper?.expand?.exam?.starts ?? userData?.expand?.exam?.starts} endsAt={userData?.expand?.questionpaper?.expand?.exam?.ends ?? userData?.expand?.exam?.ends} examState={examState} setExamState={setExamState} webcamRef={webcamRef} />
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={3}>
                <Card variant="outlined" sx={{ borderRadius: 3, boxShadow: 2, minHeight: 160, maxHeight: 160 }}>
                    <Stack justifyContent={"center"}>
                        <CardMedia
                            ref={webcamRef}
                            mirrored
                            component={Webcam}
                            audio={false}
                            height={160}
                            screenshotFormat="image/png"
                            // width={1280}
                            videoConstraints={videoConstraints}
                            sx={{ ...(mediaDevices.length === 0 && { display: "none" }) }}
                        ></CardMedia>
                        {mediaDevices.length === 0 && <Alert severity="error" sx={{ justifyContent: "center", py: 2 }}>
                            <AlertTitle>
                                No Camera Found!
                            </AlertTitle>
                            You need to have camera support on the system to attend this exam.
                        </Alert>}
                    </Stack>
                </Card>
            </Grid>
            <Grid item xs={12} sm={12} md={7} lg={8}>
                <Card sx={{ border: 1, borderColor: "divider", boxShadow: 5, borderRadius: 3, ...(!userData?.expand?.questionpaper?.expand?.exam?.id && { display: "none" }) }}>
                    <CardMedia sx={{ height: dimensions.height - 200, width: "100%", minHeight: "500px", scrollbarWidth: "thin" }} component={"div"} id="FinalQuestionPaper" />
                </Card>
            </Grid>
            {
                userData?.id &&
                userData?.expand?.questionpaper?.expand?.exam?.id &&
                <Grid item xs={12} sm={12} md={4} lg={3}>
                    <Card sx={{ border: 1, borderColor: "divider", boxShadow: 5, borderRadius: 3, height: dimensions.height - 200, width: "100%", minHeight: "500px", overflow: "auto", scrollbarWidth: "thin" }}>
                        {
                            userData?.expand?.questionpaper?.expand?.exam?.id &&
                            userData?.expand?.questionpaper?.expand?.exam?.ends &&
                            (new Date().getTime() < new Date(userData?.expand?.questionpaper?.expand?.exam?.ends).getTime()) &&
                            <CardContent>
                                <Stack spacing={2} justifyContent={"flex-start"} sx={{ p: 2 }}>
                                    {[...Array(NO_OF_QUESTIONS)].map((_, index) => (<AnswerOptions userData={userData} key={index} qno={index + 1} attempts={userAttempts?.items} deviceId={deviceId} visitorId={visitorId} />))}
                                </Stack>
                            </CardContent>
                        }
                        {
                            userData?.id &&
                            userData?.expand?.questionpaper?.expand?.exam?.id &&
                            userData?.expand?.questionpaper?.expand?.exam?.ends &&
                            (new Date().getTime() > new Date(userData?.expand?.questionpaper?.expand?.exam?.ends).getTime()) &&
                            <CardContent>
                                {/* <AttemptsXAnswers userData={userData} /> */}
                                <AttemptsOnly />
                            </CardContent>
                        }
                    </Card>
                </Grid>
            }
            <AuthRequiredComponent>
                <Dialog open={openOutOfFocusWarning} onClose={() => setOpenOutOfFocusWarning(false)} PaperProps={{ sx: { border: 3, borderRadius: 3, borderColor: "warning.main" } }} fullWidth>
                    <DialogContent>
                        <Stack direction={"row"} spacing={2} justifyContent={"center"} alignItems={"center"}>
                            <WarningAmberOutlinedIcon color="warning" />
                            <Typography align="center" variant="h4" color={"warning.main"} fontWeight={"bold"}>
                                WARNING
                            </Typography>
                            <WarningAmberOutlinedIcon color="warning" />
                        </Stack>
                        <Stack spacing={1}>
                            <Typography variant="subtitle1" fontWeight={"bold"}>
                                You went out of focus of your exam, please
                                <br />
                                • Do not switch tabs
                                <br />
                                • Do not open new tabs
                                <br />
                                • Do not loose focus of the browser
                                <br />
                            </Typography>
                            <Alert icon={false} severity="warning" sx={{ justifyContent: "center" }}>THIS MAY AFFECT YOUR RANKING</Alert>
                        </Stack>
                    </DialogContent>
                    <DialogActions>
                        <Button color="warning" sx={{ p: 2 }} onClick={() => setOpenOutOfFocusWarning(false)} fullWidth>
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>
            </AuthRequiredComponent>
        </Grid >
    );
}

const ExamStatus = ({ userData, startsAt = new Date(), endsAt = new Date(), examState, setExamState, webcamRef }) => {
    // const [now, setNow] = useState(new Date())
    const [result, setResult] = useState(false)
    const [elapsed, setElapsed] = useState(0)
    const [remaining, setRemaining] = useState(0)
    const [open, setOpen] = useState(false)
    const [openInstructions, setOpenInstructions] = useState(false)

    const navigate = useNavigate()

    const captureCam = () => {
        if (webcamRef && webcamRef?.current) {
            const imageSrc = webcamRef?.current?.getScreenshot();
            // console.log("imageSrc:", imageSrc)
            if (imageSrc) {
                urlToFile(imageSrc, `${userData?.id}_${new Date().getTime()}`).then(file => {
                    // console.log("image file: ", file)
                    const data = new FormData()
                    data.append(USER_TYPE, userData?.id)
                    data.append("camera_capture", file)
                    pb.collection('finalist_camera_captures').create(data).then(record => {
                        console.log("record created", record)
                    }).catch(err => {
                        console.log("record create error", err)
                    })
                }).catch(err => {
                    console.log("image file error", err)
                })
            }
        }
    }

    useEffect(() => {
        console.log("inside timer...")
        const timer = setInterval(() => {
            // setNow(new Date())
            let now = new Date()
            if (now.getTime() < new Date(endsAt).getTime()) {
                if (now.getTime() < new Date(startsAt).getTime()) {
                    setResult(formatDistance(now, new Date(startsAt), { includeSeconds: true }))
                    // console.log("exam not started...!")
                    setExamState(ps => ({ ...ps, started: false, ended: false, ongoing: false }))
                } else {
                    // console.log("exam started...!")
                    setResult(formatDistance(now, new Date(endsAt), { includeSeconds: true }))
                    setElapsed(Math.abs(now.getTime() - new Date(startsAt).getTime()))
                    setRemaining(Math.abs(new Date(endsAt).getTime() - now.getTime()))
                    setExamState(ps => ({ ...ps, started: true, ended: false, ongoing: true }))
                }
            } else {
                console.log("exam ended...!")
                setResult(false)
                clearInterval(timer)
                setExamState(ps => ({ ...ps, started: true, ended: true, ongoing: false }))
            }

        }, 1 * 1000);

        return () => clearInterval(timer)
    }, [startsAt, endsAt, setExamState])

    const _progress = Math.abs(new Date(endsAt).getTime() - new Date(startsAt).getTime()) !== 0 ? 100 * (elapsed / Math.abs(new Date(endsAt).getTime() - new Date(startsAt).getTime())) : 0
    const duration = Math.abs(new Date(endsAt).getTime() - new Date(startsAt).getTime())

    return (
        <Box sx={{ border: 1, borderColor: "divider", borderRadius: 3, boxShadow: 5 }}>
            <ListItem key={'exam-details'} divider>
                <ListItemAvatar>
                    <Avatar src={CRRaoAIMSCSLogo} variant="rounded" sx={{ background: "transparent" }}>
                        <TaskIcon color="info" />
                    </Avatar>
                </ListItemAvatar>
                <ListItemText primary={userData?.expand?.questionpaper?.expand?.exam?.name ?? userData?.expand?.exam?.name ?? "Exam Not Available!"} secondary={
                    `Level ${userData?.expand?.questionpaper?.expand?.exam?.level ?? userData?.expand?.exam?.level ?? "NA"} • ${userData?.expand?.questionpaper?.expand?.exam?.type ?? userData?.expand?.exam?.type ?? "NA"}`
                } />
                <ListItemIcon>
                    <Button onClick={() => setOpenInstructions(true)} startIcon={<InfoIcon />} color="info" sx={{ px: 2, borderRadius: 5 }}>INSTRUCTIONS</Button>
                    <AuthRequiredComponent>
                        {pb?.authStore?.model?.id && _progress !== 0 && new Date().getTime() > new Date(startsAt).getTime() && new Date().getTime() < new Date(endsAt).getTime() && <Button onClick={() => setOpen(true)}
                            startIcon={<StopIcon />} color="error" sx={{ px: 2, borderRadius: 5 }}>END EXAM</Button>
                        }
                    </AuthRequiredComponent>
                    {/* <Button startIcon={<StopIcon />} color="error" sx={{ px: 2, borderRadius: 5 }}>END EXAM</Button> */}
                </ListItemIcon>
            </ListItem>
            <ListItem key={'exam-time-details'}>
                {/* <ListItemAvatar>
                    <Box sx={{ position: "relative" }}>
                        <CircularProgress value={_progress} thickness={6} variant="determinate" color={_progress === 0 ? "error" : _progress < 50 ? "success" : _progress < 80 ? "warning" : "error"} />
                        <Box sx={{ position: "absolute", top: 0, left: 0 }}>
                            <CircularProgress value={100} thickness={6} variant="determinate" sx={{ color: "text.disabled" }} />
                        </Box>
                    </Box>
                </ListItemAvatar> */}
                <ListItemText sx={{ pr: 1 }}
                    primary={pb?.authStore?.model?.username}
                />
            </ListItem>
            <Stack spacing={0.5} sx={{ px: 2, pb: 1 }}>
                <LinearProgress sx={{ borderRadius: 10 }} value={_progress} color={_progress === 0 ? "error" : _progress < 50 ? "success" : _progress < 80 ? "warning" : "error"} variant="determinate" />
                <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
                    <Typography variant="subtitle2" color={"text.secondary"}>
                        {`${convertMsToTime(elapsed)}`}
                    </Typography>
                    <Typography variant="subtitle2" color={"text.secondary"}>
                        {result ? `in ${result} ${(!examState.started && !examState.ended && !examState.ongoing) ? " exam will start." : ""} ${(examState.started && !examState.ended && examState.ongoing) ? " exam will end." : ""}` : `${(examState.started && examState.ended) ? " exam ended" : ""}`}
                    </Typography>
                    <Typography variant="subtitle2" color={"text.secondary"}>
                        {`${convertMsToTime(remaining)}`}
                    </Typography>
                </Stack>
            </Stack>
            <AuthRequiredComponent>
                <Dialog open={open} onClose={() => setOpen(false)} PaperProps={{ sx: { borderRadius: 3 } }}>
                    <DialogContent>
                        <Typography align="center" variant="subtitle1">Do you really want to exit the exam?</Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button color="secondary" onClick={() => setOpen(false)} fullWidth>
                            No
                        </Button>
                        <Button color="error" onClick={() => { pb.authStore.clear(); navigate("/") }} fullWidth>
                            Yes
                        </Button>
                    </DialogActions>
                </Dialog>
            </AuthRequiredComponent>
            <Dialog open={openInstructions} onClose={() => setOpenInstructions(false)} PaperProps={{ sx: { borderRadius: 3 } }} fullWidth>
                <DialogContent sx={{ maxHeight: 500 }}>
                    <FinalistInstructions />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenInstructions(false)} fullWidth>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}

const AttemptsOnly = () => {
    const [attempts, setAttempts] = useState({})
    const [sortedAttempts, setSortedAttempts] = useState({})

    useEffect(() => {
        if (pb?.authStore?.model?.id) {
            pb.collection('finalists').getOne(`${pb?.authStore?.model?.id}`, {
                expand: 'questionpaper, questionpaper.exam',
            }).then(finalist => {
                // console.log("finalist: ", finalist)
                pb.collection('readonly_finalist_attempts').getList(1, 100, {
                    filter: `questionpaper.exam = '${finalist?.expand?.questionpaper?.exam}'`,
                }).then(ro_attempts => {
                    setAttempts(ro_attempts)
                }).catch(error => {
                    console.log("attempt error:", error)
                })
            }).catch(error => {
                console.log("finalist error:", error)
            })

        }
    }, [])

    useEffect(() => {
        if (attempts?.items && attempts?.items.length > 0) {
            let tempAttempts = {}
            const sortedA = attempts?.items.filter(x => x?.questionnumber && x).sort((a, b) => a.questionnumber - b.questionnumber)
            for (const attempt of sortedA) {
                tempAttempts[attempt?.questionnumber] = attempt
            }
            setSortedAttempts(sortedA)
        }
    }, [attempts])

    useEffect(() => {
        if (sortedAttempts) {
            console.log("sortedAttempts: ", sortedAttempts)
        }
    }, [sortedAttempts])


    return (
        <Stack spacing={1} justifyContent={"center"}>

            {Object.keys(sortedAttempts) && sortedAttempts.length > 0 && sortedAttempts.map((attempt, index) => (
                <Stack key={index} direction={"row"} spacing={1} alignItems={"flex-end"} justifyContent={"flex-start"}>
                    <ToggleButtonGroup
                        value={attempt?.option}
                        fullWidth
                        disabled
                    >
                        <ToggleButton sx={{ py: 1, fontFamily: "JetBrains Mono", fontWeight: "bold" }} disabled={true} value={attempt?.questionnumber}>
                            {`${attempt?.questionnumber}`.toString().padStart(3, "0")}.
                        </ToggleButton>
                        <ToggleButton sx={{ py: 1 }} value="A" color={"info"}>
                            <Typography variant="h6" sx={{ fontFamily: "JetBrains Mono", fontWeight: "bold" }}>A</Typography>
                        </ToggleButton>
                        <ToggleButton sx={{ py: 1 }} value="B" color={"info"}>
                            <Typography variant="h6" sx={{ fontFamily: "JetBrains Mono", fontWeight: "bold" }}>B</Typography>
                        </ToggleButton>
                        <ToggleButton sx={{ py: 1 }} value="C" color={"info"}>
                            <Typography variant="h6" sx={{ fontFamily: "JetBrains Mono", fontWeight: "bold" }}>C</Typography>
                        </ToggleButton>
                        <ToggleButton sx={{ py: 1 }} value="D" color={"info"}>
                            <Typography variant="h6" sx={{ fontFamily: "JetBrains Mono", fontWeight: "bold" }}>D</Typography>
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Stack>
            ))}
        </Stack>
    )
}

const AttemptsXAnswers = () => {
    const [answers, setAnswers] = useState({})
    const [attempts, setAttempts] = useState({})
    const [sortedAttempts, setSortedAttempts] = useState({})
    const [marks, setMarks] = useState({ rights: 0, wrongs: 0, questions: 0, attempts: 0 })

    useEffect(() => {
        if (pb?.authStore?.model?.id) {
            pb.collection('finalists').getOne(`${pb?.authStore?.model?.id}`, {
                expand: 'questionpaper, questionpaper.exam',
            }).then(finalist => {
                // console.log("finalist: ", finalist)
                pb.collection('readonly_finalist_attempts').getList(1, 100, {
                    filter: `questionpaper.exam = '${finalist?.expand?.questionpaper?.exam}'`,
                }).then(ro_attempts => {
                    setAttempts(ro_attempts)
                }).catch(error => {
                    console.log("attempt error:", error)
                })
                pb.collection('readonly_answers').getFirstListItem(`questionpaper.exam = '${finalist?.expand?.questionpaper?.exam}'`).then(ro_answers => {
                    if (ro_answers?.answers) {
                        // console.log("readonly answers:", ro_answers)
                        setAnswers(ro_answers?.answers)
                    }
                }).catch(error => {
                    console.log("answer read error: ", error)
                })
            }).catch(error => {
                console.log("finalist error:", error)
            })

        }
    }, [])

    // useEffect(() => {
    //     answers && answers.length > 0 && console.log("answers: ", answers)
    // }, [answers])

    useEffect(() => {
        if (attempts?.items && attempts?.items.length > 0) {
            let tempAttempts = {}
            const sortedA = attempts?.items.filter(x => x?.questionnumber && x).sort((a, b) => a.questionnumber - b.questionnumber)
            for (const attempt of sortedA) {
                tempAttempts[attempt?.questionnumber] = attempt
            }
            setSortedAttempts(tempAttempts)
        }
    }, [attempts])

    useEffect(() => {
        if (answers && answers.length > 0 &&
            attempts && attempts?.items &&
            attempts?.items?.length > 0 &&
            sortedAttempts &&
            Object.keys(sortedAttempts).length > 0
        ) {
            console.log("calculating marks... ")
            const rightsNWrongs = answers.map((answer, index) => (answer.split(",").includes(sortedAttempts?.[index + 1]?.option) || answer === sortedAttempts?.[index + 1]?.option ? { qno: index + 1, option: sortedAttempts?.[index + 1]?.option, answer: answer, correct: true } : { qno: index + 1, option: sortedAttempts?.[index + 1]?.option, answer: answer, correct: false }))
            console.log("calculated marks: %O", rightsNWrongs)
            const rights = rightsNWrongs.filter(x => x?.option && x?.correct && x)
            const wrongs = rightsNWrongs.filter(x => x?.option && !x?.correct && x)
            setMarks(ps => ({ ...ps, rights: rights, wrongs: wrongs, attempts: attempts?.totalItems, questions: answers.length, valid: attempts?.totalItems === rights.length + wrongs.length }))
        }
    }, [sortedAttempts, attempts, answers])


    return (
        <Stack spacing={1} justifyContent={"center"}>
            {marks.valid && <Card variant="outlined" sx={{ borderRadius: 3 }}>
                <CardContent>
                    <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
                        <Typography variant="subtitle2" color={"success.main"}>Rights</Typography>
                        <Typography variant="subtitle1" color={"success.main"} fontWeight={"medium"}>{marks.rights && marks.rights.length}</Typography>
                    </Stack>
                    <LinearProgress variant="determinate" sx={{ borderRadius: 10 }} value={marks.rights && marks.rights.length} color="success" />
                    {/* <Divider /> */}
                    <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
                        <Typography variant="subtitle2" color={"error.main"}>Wrongs</Typography>
                        <Typography variant="subtitle1" color={"error.main"} fontWeight={"medium"}>{marks.wrongs && marks.wrongs.length}</Typography>
                    </Stack>
                    <LinearProgress variant="determinate" sx={{ borderRadius: 10 }} value={marks.wrongs && marks.wrongs.length} color="error" />
                    {/* <Divider /> */}
                    <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
                        <Typography variant="subtitle2" color={"secondary.main"}>Ignored</Typography>
                        <Typography variant="subtitle1" color={"secondary.main"} fontWeight={"medium"}>{answers && answers.length && attempts && answers.length - attempts.totalItems}</Typography>
                    </Stack>
                    <LinearProgress variant="determinate" sx={{ borderRadius: 10 }} value={answers && answers.length && attempts && answers.length - attempts.totalItems} color="secondary" />
                    {/* <Divider /> */}
                    <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
                        <Typography variant="subtitle2" color={"info.main"}>Attempted</Typography>
                        <Typography variant="subtitle1" color={"info.main"} fontWeight={"medium"}>{attempts && attempts.totalItems}</Typography>
                    </Stack>
                    <LinearProgress variant="determinate" sx={{ borderRadius: 10 }} value={attempts && attempts.totalItems} color="info" />
                    {/* <Divider /> */}
                    <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
                        <Typography variant="subtitle2" color={"text.secondary"}>Questions</Typography>
                        <Typography variant="subtitle1" color={"text.secondary"} fontWeight={"medium"}>{answers && answers.length}</Typography>
                    </Stack>
                    <LinearProgress variant="determinate" sx={{ borderRadius: 10 }} value={answers && answers.length} color="inherit" />
                </CardContent>
            </Card>}

            {answers && answers.length > 0 && answers.map((answer, index) => (
                <Stack key={index} direction={"row"} spacing={1} alignItems={"flex-end"} justifyContent={"flex-start"}>
                    <ToggleButtonGroup
                        value={[answer, ...[sortedAttempts?.[index + 1]?.option]]}
                        fullWidth
                    >
                        <ToggleButton sx={{ py: 1, fontFamily: "JetBrains Mono", fontWeight: "bold" }} disabled={true} value={index + 1}>
                            {`${index + 1}`.toString().padStart(3, "0")}.
                        </ToggleButton>
                        <ToggleButton sx={{ py: 1 }} value="A" color={answer.split(",").includes("A") || answer === "A" ? "success" : "error"}>
                            <Typography variant="h6" sx={{ fontFamily: "JetBrains Mono", fontWeight: "bold" }}>A</Typography>
                        </ToggleButton>
                        <ToggleButton sx={{ py: 1 }} value="B" color={answer.split(",").includes("B") || answer === "B" ? "success" : "error"}>
                            <Typography variant="h6" sx={{ fontFamily: "JetBrains Mono", fontWeight: "bold" }}>B</Typography>
                        </ToggleButton>
                        <ToggleButton sx={{ py: 1 }} value="C" color={answer.split(",").includes("C") || answer === "C" ? "success" : "error"}>
                            <Typography variant="h6" sx={{ fontFamily: "JetBrains Mono", fontWeight: "bold" }}>C</Typography>
                        </ToggleButton>
                        <ToggleButton sx={{ py: 1 }} value="D" color={answer.split(",").includes("D") || answer === "D" ? "success" : "error"}>
                            <Typography variant="h6" sx={{ fontFamily: "JetBrains Mono", fontWeight: "bold" }}>D</Typography>
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Stack>
            ))}
        </Stack>
    )
}

const AnswerOptions = ({ userData, qno = 0, attempts, deviceId, visitorId }) => {
    const [option, setOption] = useState('');

    useEffect(() => {
        if (Array.isArray(attempts)) {
            const isAttempted = attempts.filter(x => x?.option && x?.questionnumber === qno && x)
            setOption(isAttempted?.[0]?.option)
        }
    }, [attempts, qno])

    const handleOption = (event, newOption) => {
        if (newOption !== null && qno > 0) {
            const data = {
                "finalist": userData?.id,
                "questionpaper": userData?.questionpaper,
                "questionnumber": qno,
                "option": newOption,
                "deviceId": deviceId,
                "fingerprint": visitorId,
            };

            console.log("attempt payload:", data)
            pb.collection('finalist_attempts').getList(1, 100, {
                filter: `questionpaper = '${userData?.questionpaper}' && questionnumber = ${qno}`,
            }).then(record => {
                // console.log("Attempt Record", record)
                if (record.items.length === 0) {
                    pb.collection('finalist_attempts').create(data)
                        .then(record => {
                            // console.log("Attempt Created", record)
                            setOption(record?.option ? record?.option : "");
                        }).catch(error => {
                            console.log("attempt create error:", error)
                        })
                } else if (record?.items?.[0].id) {
                    pb.collection('finalist_attempts').update(record?.items?.[0].id, data)
                        .then(record => {
                            // console.log("Attempt Updated", record)
                            setOption(record?.option ? record?.option : "");
                        }).catch(error => {
                            console.log("attempt update error:", error)
                        })
                }
            }).catch(error => {
                console.log("attempt error:", error)
            })
        }
        // setOption(newOption);
    };

    return (
        <Stack direction={"row"} spacing={1} alignItems={"flex-end"} justifyContent={"flex-start"}>
            <ToggleButtonGroup
                value={option}
                exclusive
                onChange={handleOption}
                color="info"
                fullWidth
            >
                <ToggleButton sx={{ py: 1, fontFamily: "JetBrains Mono", fontWeight: "bold" }} disabled={true} value={qno}>
                    {qno.toString().padStart(3, "0")}.
                </ToggleButton>
                <ToggleButton sx={{ py: 1 }} value="A">
                    <Typography variant="h6" sx={{ fontFamily: "JetBrains Mono", fontWeight: "bold" }}>A</Typography>
                </ToggleButton>
                <ToggleButton sx={{ py: 1 }} value="B">
                    <Typography variant="h6" sx={{ fontFamily: "JetBrains Mono", fontWeight: "bold" }}>B</Typography>
                </ToggleButton>
                <ToggleButton sx={{ py: 1 }} value="C">
                    <Typography variant="h6" sx={{ fontFamily: "JetBrains Mono", fontWeight: "bold" }}>C</Typography>
                </ToggleButton>
                <ToggleButton sx={{ py: 1 }} value="D">
                    <Typography variant="h6" sx={{ fontFamily: "JetBrains Mono", fontWeight: "bold" }}>D</Typography>
                </ToggleButton>
            </ToggleButtonGroup>
        </Stack>
    )
}